import { createContext, useContext } from "react";
import type { RyftAccountGetResponseType } from "@sellar-io/api-v2/types";
import { RyftOnboardingStepId, RyftOnboardingStepStatus } from "../types";

export type RyftRequiredDocument = NonNullable<
  RyftAccountGetResponseType["verification"]["requiredDocuments"]
>[number];

export type RyftUploadedDocument =
  RyftAccountGetResponseType["uploadedDocuments"][number];

export type RyftNonHostedOnboardingContext = {
  account: RyftAccountGetResponseType | undefined;
  error: unknown;
  onboardingSteps: Record<RyftOnboardingStepId, RyftOnboardingStepStatus>;
  isLoading: boolean;
};

export const RyftNonHostedOnboardingContext =
  createContext<RyftNonHostedOnboardingContext | null>(null);

export const useRyftNonHostedOnboarding = () => {
  const context = useContext(RyftNonHostedOnboardingContext);

  if (!context) {
    throw new Error(
      "useRyftNonHostedOnboarding() must be used within <RyftNonHostedOnboardingProvider />",
    );
  }

  return context;
};
